import { DEFAULT_IMAGE_SCALE, IMAGE_SCALES, type ImageScale } from "../enums/exports";

/**
 * On Lambda, `@sparticuz/chromium` routes all rendering through SwANGLE (ANGLE over SwiftShader
 * Vulkan), whose maximum surface size is 8192px per side.
 */
export const MAX_SCREENSHOT_DIMENSION_PX = 8192;

export const isImageScale = (value: unknown): value is ImageScale => IMAGE_SCALES.includes(value as ImageScale);

/** The largest scale that keeps the output within MAX_SCREENSHOT_DIMENSION_PX. Never below 1x. */
export const getMaxImageScale = (width: number, height: number): ImageScale => {
    const longestSide = Math.max(width || 0, height || 0);

    if (longestSide <= 0) {
        return IMAGE_SCALES[IMAGE_SCALES.length - 1];
    }

    const usable = IMAGE_SCALES.filter((scale) => longestSide * scale <= MAX_SCREENSHOT_DIMENSION_PX);

    return usable.length ? usable[usable.length - 1] : IMAGE_SCALES[0];
};

/** Clamps a requested scale to what the template dimensions support. Anything unusable becomes 1x. */
export const clampImageScale = (scale: number | undefined, width: number, height: number): ImageScale => {
    const requested = isImageScale(scale) ? scale : DEFAULT_IMAGE_SCALE;

    return Math.min(requested, getMaxImageScale(width, height)) as ImageScale;
};
